export default __webpack_public_path__ + "static/media/taskmo_logo.d1652f07.svg";